import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const OUTBOUND_SMS_BANNER_HEIGHT = 40;
export const BannerWrapper = styled(Box).attrs({
  width: '100%',
  borderRadius: '5px',
  align: 'center',
  bg: 'primaryBase',
  height: OUTBOUND_SMS_BANNER_HEIGHT,
  py: '12px',
  px: '20px',
})``;
export const TextIconWrapper = styled(Box).attrs({
  align: 'center',
  justify: 'flex-start',
})``;
export const BannerText = styled(Text).attrs({
  color: 'background',
  ml: '12px',
  size: 'normal',
})``;
export const IconWrapper = styled(Box).attrs({
  color: 'background',
})``;
